import cx from 'classnames'
import PrevIcon from '../../../../public/assets/calendar-nav-prev-icon.svg'
import NextIcon from '../../../../public/assets/calendar-nav-next-icon.svg'
import styles from '../Calendar.module.scss'

import CalendarFilter from './CalendarFilter'
import { MonthProps } from '~types'
import { isNextButtonDisabled, isPrevButtonDisabled } from '../utils'

interface CalendarTopNavigationProps {
  selectedMonth: MonthProps
  setSelectedMonth: (month: MonthProps) => void
  activeMonthList: string[]
  toggleView?: React.ReactNode
  handleNavigation: (key: string) => void
  isTablet: boolean
}

const CalendarTopNavigation = ({
  selectedMonth,
  setSelectedMonth,
  activeMonthList,
  toggleView,
  handleNavigation,
  isTablet
}: CalendarTopNavigationProps) => {
  const currentMonthKey = selectedMonth?.shortLabel.replace(/\s+/g, '-')

  const renderNavigationButtons = () => (
    <div className={styles['calendar-nav-buttons']}>
      <div className={styles['previous']}>
        <button
          onClick={() => handleNavigation('previous')}
          aria-label='Previous Month'
          disabled={isPrevButtonDisabled(currentMonthKey, activeMonthList)}
        >
          <PrevIcon />
        </button>
      </div>
      <div className={styles['next']}>
        <button
          onClick={() => handleNavigation('next')}
          aria-label='Next Month'
          disabled={isNextButtonDisabled(currentMonthKey, activeMonthList)}
          className={styles.calendarNavButton}
        >
          <NextIcon />
        </button>
      </div>
    </div>
  )

  return (
    <div className={cx(styles['calendar__month-navs'], styles['calendar__month-navs--top'])}>
      {!isTablet && (
        <>
          <button title='Today' onClick={() => handleNavigation('today')} className={styles['calendar__today-button']}>
            Today
          </button>
          <div className={styles['calendar__divider']} />
        </>
      )}

      <CalendarFilter
        selectedMonth={selectedMonth}
        activeMonthList={activeMonthList}
        handleMonthNavChange={setSelectedMonth}
      />

      {!isTablet && renderNavigationButtons()}

      {toggleView}
    </div>
  )
}

export default CalendarTopNavigation
